module.exports = __webpack_public_path__ + "img/69.e9dced12.jpeg";